import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { merge } from 'lodash';
import * as productTRTypes from './productTRTypes';

const byId = handleActions(
  {
    [productTRTypes.PRODUCT_TR_LIST.SUCCESS]: (state, { payload }) =>
      merge({}, state, payload.entities.productsTR),
  },
  {},
);

const allIds = handleActions(
  {
    [productTRTypes.PRODUCT_TR_LIST.SUCCESS]: (state, { payload }) => payload.result,
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
